import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    isVisible: false,
    component: "",
};
function reducer(state = defaultState, {type, payload }: reduxType) {
    switch (type) {
        case "setReportsModal":
            return payload
        default:
            return state;    
    }
}
export default reducer;